import { module } from 'modujs';
import ModelViewer from './ModelViewer'

export default class extends ModelViewer {
    constructor(m) {
        super(m);

        // this.autoplayAnimations = false
        this.defaultAnimation = 'walking';
    }        

    init() {
        super.init() 

        // requestAnimationFrame(() => {
        //     window.addEventListener('mousemove', e => {
        //         // console.log(this.camera);
        //         // console.log(e.clientX/window.innerWidth * 8 - 4);
        //         // this.wrapper.rotation.set(0,e.clientX/window.innerWidth * 0.25,0)
        //         // this.wrapper.scale.set(0.75,(Math.sin(e.clientX/window.innerWidth * 4)+1) + 0.75,0.75)
        //     })
        // })        
    }

    render() {
        super.render();

        this.wrapper.rotation.set(0,this.wrapper.rotation.y + (0.02 * this.deltaTime/(1/60)),0)
    }

    initScene() {
        super.initScene();

        this.camera.position.set(1,3,5)
        this.controls.target.set(0, .75, 0)
        this.wrapper.scale.set(0.75,0.75,0.75);
    }    
}
